import React from 'react';
import { node } from 'prop-types';

import styles from './TypeDWrapper.css';

const TypeDWrapper = ({ children  }) => (
  <div className={styles.container}>
      {children}
  </div>
);

TypeDWrapper.propTypes = {
  children: node,
};

TypeDWrapper.displayName = 'TypeDWrapper';

export default TypeDWrapper;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/HeroBanner/TypeD/TypeDWrapper.js